<template>
  <div>
    <div class="relative flex flex-col mb-6 mt-12 z-10">
      <!-- <h1 class="ang-heading mb-8">Zarządzaj swoimi zgodami</h1> -->
      <div class="ang-card">
        <div class="ang-card-body p-15 cursor-default">
          <div class="relative w-auto">
            <div class="px-8 py-6 relative flex flex-col w-full text-current">
              <h4 class="text-xl font-medium mb-4">
                Wycofywanie zgody na przetwarzanie Twoich danych w celach
                marketingowych
              </h4>
              <form
                v-show="verified > 0"
                role="form"
                id="unsubscribe-form"
                class=""
                :action="action"
                method="POST"
                novalidate="novalidate"
              >
                <div class="row">
                  <div class="col-12 mt-2">
                    <div class="mb-5">
                      <label class="cursor-pointer text-xs mt-6">
                        Udzieliłaś/-eś nam zgody na otrzymywanie informacji
                        marketingowych drogą elektroniczną. Czy chcesz wycofać
                        zgodę na przesyłanie przez Grupę ANG S.A. z siedzibą w
                        Warszawie informacji marketingowych drogą elektroniczną
                        (e-mail, SMS)?
                      </label>
                    </div>
                  </div>
                </div>
              </form>
              <div class="flex justify-between" v-if="verified > 0">
                <button
                  :disabled="sent && !loading"
                  @click.stop.prevent="cancelConsent()"
                  class="btn ang-button py-1.5 px-4 _bg_color2"
                >
                  Wycofaj
                </button>
                <spinner v-if="loading"></spinner>
              </div>
            </div>
            <div
              v-if="sent"
              class="bg-[#fff7e1] border-2 border-solid border-[#FFE6A4] rounded-xl px-5 py-2"
            >
              <label class="cursor-pointer text-xs mt-2">
                Na Twój adres e-mail wysłaliśmy potwierdzenie wycofania zgody na
                przesyłanie przez Grupę ANG S.A. z siedzibą w Warszawie
                informacji marketingowych drogą elektroniczną (e-mail, SMS).
              </label>
            </div>
            <div
              v-if="error || verified < 0"
              class="bg-[#fad2cf] border-2 border-solid border-[#fa6257] rounded-xl px-5 py-2"
            >
              <label class="cursor-pointer text-xs mt-2">
                Wystąpił niespodziewany błąd
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
#credit-holidays-form label.error,
#unsubscribe-form label.error {
  position: absolute;
  font-size: 11px;
}
#scheduleModal.show,
#contactModal.show {
  display: block !important;
}
.accordion-button:not(.collapsed) {
  color: #47404f !important;
}
</style>
<script>
// import datepicker from "eonasdan-bootstrap-datetimepicker"; // eslint-disable-line
import api from "@/services/api";
import ajax from "@/services/ajax";
// import moment from "moment";
import $ from "jquery";
import spinner from "@/components/partials/misc/spinner";

export default {
  data() {
    return {
      loading: false,
      error: false,
      sent: false,
      hash: null,
      verified: 0,
    };
  },
  name: "Holidays",
  components: { spinner },
  mounted() {
    let self = this;
    if (typeof this.$route.params.hash !== "undefined") {
      this.hash = this.$route.params.hash;
    } else {
      window.location.href = "https://grupaang.pl";
      return;
    }

    api.get(
      "/client/checktoken/" + self.hash,
      { code: null },
      function (data) {
        self.verified = 1;
        console.log(data);
      },
      function (data) {
        self.verified = -1;
        console.log(data);
      }
    );
    this.$nextTick(function () {
      ajax.postValidate(
        $("#unsubscribe-form"),
        self,
        function () {
          self.sent = true;
          self.error = false;
          self.loading = false;
          // document.getElementById("closeContactModal").click();
        },
        function () {
          self.loading = false;
          self.error = true;
          // document.getElementById("closeContactModal").click();
        }
      );
    });
  },
  computed: {
    action() {
      return "/clients/" + this.hash + "/unsubscribe";
    },
  },
  methods: {
    cancelConsent() {
      if (this.sent) return;
      this.error = false;
      this.loading = true;
      $("#unsubscribe-form").submit();
    },
  },
};
</script>
